import { render } from "./VideoWallCameraListGroupHeader.vue?vue&type=template&id=24d2421a&ts=true"
import script from "./VideoWallCameraListGroupHeader.vue?vue&type=script&lang=ts"
export * from "./VideoWallCameraListGroupHeader.vue?vue&type=script&lang=ts"

import "./VideoWallCameraListGroupHeader.vue?vue&type=style&index=0&id=24d2421a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__